import { z } from 'zod';
/** TechSpec §3.2 / §9.5 — dashboards and their layouts. */
export const DASHBOARD_MODES = ['web', 'spotlight', 'overlay', 'drawer', 'monitor'];
export const GRID_COLUMNS = 12;
export const MAX_LAYOUT_ITEMS = 100;
const MAX_PROPS_BYTES = 16_384;
/**
 * One placed widget. The API checks the shape, never the widget's props: an
 * unknown or invalid widget is shown as an error by the frame, never dropped.
 */
export const LayoutItemSchema = z
    .object({
    i: z.string().min(1).max(64),
    x: z
        .number()
        .int()
        .min(0)
        .max(GRID_COLUMNS - 1),
    y: z.number().int().min(0).max(10_000),
    w: z.number().int().min(1).max(GRID_COLUMNS),
    h: z.number().int().min(1).max(100),
    widget: z.object({
        type: z.string().min(1).max(64),
        props: z
            .record(z.string(), z.unknown())
            .refine((p) => JSON.stringify(p).length <= MAX_PROPS_BYTES, 'props too large'),
    }),
})
    .refine((item) => item.x + item.w <= GRID_COLUMNS, 'item overflows the grid');
export const LayoutSchema = z
    .array(LayoutItemSchema)
    .max(MAX_LAYOUT_ITEMS)
    .refine((items) => new Set(items.map((i) => i.i)).size === items.length, 'duplicate item id');
export const DashboardSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    mode: z.enum(DASHBOARD_MODES),
    layout: z.array(LayoutItemSchema),
    isDefault: z.boolean(),
    createdAt: z.iso.datetime({ offset: true }),
    updatedAt: z.iso.datetime({ offset: true }),
});
export const DashboardListResponseSchema = z.object({ dashboards: z.array(DashboardSchema) });
export const DashboardListQuerySchema = z.object({
    mode: z.enum(DASHBOARD_MODES).optional(),
});
export const CreateDashboardRequestSchema = z.object({
    name: z.string().trim().min(1).max(120),
    mode: z.enum(DASHBOARD_MODES).default('web'),
    layout: LayoutSchema.default([]),
    isDefault: z.boolean().default(false),
});
export const UpdateDashboardRequestSchema = z
    .object({
    name: z.string().trim().min(1).max(120),
    layout: LayoutSchema,
    isDefault: z.boolean(),
})
    .partial();
//# sourceMappingURL=dashboards.js.map